import handleAnchorLink from './handleAnchorLink';

import handleToTop from './handleScrollToTop';

import handleTriggerHoverInViewport from './handleTriggerHoverInViewport';

import fancyBox from './fancybox';

/**
 * Set up global functionalities, such as link handling.
 */

$(document).on('click', 'a[href*="#"]', handleAnchorLink());

window.addEventListener('load', handleTriggerHoverInViewport);
window.addEventListener('scroll', handleTriggerHoverInViewport);

const productDiv = document.querySelectorAll('div[data-gallery="product"]');
const toTopButton = document.querySelector('#t3m-toTop');

if (productDiv.length) {
    $(document).ready(() => {
        fancyBox();
    });
}

if (toTopButton) {
    handleToTop(toTopButton);
}



// WEBPACK FOOTER //
// ./src/scripts/components/global/index.js